<template>
  <div class="success-screen">
    <div class="success-box">
      <h2>退租已登記</h2>
      <!-- <img src="@/assets/icon_success.png" alt="Submission Success" class="success-icon" /> -->
      <img src="@/assets/Paomedia-Small-N-Flat-Sign-warning.svg" alt="Submission Success" class="success-icon" />

      <p>請確認是否有收到退租登記的 Mail<br>
         ✱如未成功者，請再重新登記✱</p>
    </div>
    <button @click="reset" class="success-button">回到首頁</button>
  </div>
</template>

<script>
export default {
  methods: {
    reset() {
      this.$router.push('/');
    }
  }
};
</script>

<style scoped>
@import "@/css/apply_success.css";

</style>
